module.exports = (__webpack_require__(0))(188);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/AdminView.js from dll-reference girder_lib
// module id = 48
// module chunks = 0